<div>
  <div class="rs-modal-close">
    <button class="rs-link-action rs-link-action-close close-reveal-modal" (click)="close()">
      <span class="rs-action-link-icon" title="{{ 'common.overlayer.close.caption' | translate }}"
        ><span class="show-for-sr">{{ 'common.overlayer.close.caption' | translate }}</span></span
      >
    </button>
  </div>
  <div class="rs-modal-heading">
    <h2 *ngIf="plc === PlcCodes.O365" class="rs-modal-heading-title" id="modal_label_O365">
      {{ 'products.legacy.O365.title' | translate }}
    </h2>
    <h2 *ngIf="plc === PlcCodes.NIS" class="rs-modal-heading-title" id="modal_label_SEC">
      {{ 'products.legacy.NIS.title' | translate }}
    </h2>
    <h2 *ngIf="plc === PlcCodes.FM" class="rs-modal-heading-title" id="modal_label_FM">
      {{ 'products.legacy.FM.title' | translate }}
    </h2>
    <h2 *ngIf="plc === PlcCodes.DV" class="rs-modal-heading-title" id="modal_label_DV">
      {{ 'products.legacy.DV.title' | translate }}
    </h2>
    <span *ngIf="plc === PlcCodes.LDM"
      ><h2 class="rs-modal-heading-title" id="modal_label_LDM">
        {{ 'products.overview.ldm.title' | translate }}
      </h2>
      <h3 class="rs-modal-heading-subtit">{{ 'products.overview.ldm.subtitle' | translate }}</h3>
    </span>
  </div>
  <div class="rs-modal-content">
    <p *ngIf="plc === PlcCodes.O365">
      {{ 'products.legacy.O365.desc' | translate }}
    </p>
    <p *ngIf="plc === PlcCodes.NIS">
      {{ 'products.legacy.NIS.desc' | translate }}
    </p>
    <p *ngIf="plc === PlcCodes.FM">
      {{ 'products.legacy.FM.desc' | translate }}
    </p>
    <p *ngIf="plc === PlcCodes.DV">
      {{ 'products.legacy.DV.desc' | translate }}
    </p>
    <span *ngIf="plc === PlcCodes.LDM" data-cy="ldmChangeSubscriptionModal">
      <p>{{ 'products.overview.ldm.desc1' | translate }}</p>
      <p>{{ 'products.overview.ldm.desc2' | translate }}</p>
    </span>
  </div>
  <div class="rs-modal-footer" *ngIf="plc === PlcCodes.LDM">
    <div
      class="rs-flex-row rs-flex-middle-medium rs-justify-right-medium rs-flex-dir-col-small-only"
    >
      <div class="rs-flex-columns rs-flex-shrink rs-order-m2">
        <a
          href="{{ 'products.overview.ldm.button.callMeBack.link' | translate }}"
          class="rs-btn rs-btn-nl-so"
          data-cy="ldmChangeSubscriptionModalCallMeBackButton"
          >{{ 'products.overview.ldm.button.callMeBack' | translate }}</a
        >
      </div>
      <div class="rs-flex-columns rs-order-m1">
        <a
          href="{{ 'products.overview.ldm.button.cease.link' | translate }}"
          class="rs-btn rs-btn-second rs-btn-nl-m close-reveal-modal"
          data-cy="ldmChangeSubscriptionModalCancelButton"
        >
          {{ 'products.overview.ldm.button.cancel' | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
